<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" fixed app v-if="CanI('UseMenu')">
      <v-list dense>
        <v-list-tile
          :to="{ name: 'home', params: { user_id: user.uid } }"
          v-if="!CanI('HaveNoTimesheet')"
        >
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>ホーム</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'manage_attendance' }">
          <v-list-tile-action>
            <v-icon>assignment</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>勤怠管理</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'manage_timesheets' }">
          <v-list-tile-action>
            <v-icon>calendar_today</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>タイムシート管理</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          :to="{ name: 'manage_paid_days_off' }"
          v-if="CanI('ManagePaidDaysOff')"
        >
          <v-list-tile-action>
            <v-icon>calendar_today</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>有給管理</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          :to="{ name: 'attendance_result' }"
          v-if="CanI('UseAttendanceResult')"
        >
          <v-list-tile-action>
            <v-icon>playlist_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>月次集計</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          :to="{ name: 'manage_costs' }"
          v-if="CanI('UseAttendanceResult')"
        >
          <v-list-tile-action>
            <v-icon>playlist_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>原価集計</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          :to="{ name: 'manage_expenses' }"
          v-if="CanI('UseAttendanceResult')"
        >
          <v-list-tile-action>
            <v-icon>playlist_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>経費管理</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'users' }" v-if="CanI('UseAttendanceResult')">
          <v-list-tile-action>
            <v-icon>group</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>ユーザー管理</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="deep-orange" class="non-printable" dark fixed app>
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        v-if="CanI('UseMenu')"
      ></v-toolbar-side-icon>
      <v-toolbar-title>Pragma Apps</v-toolbar-title>
      <v-spacer></v-spacer>
      {{ userName }}
      <v-toolbar-items v-if="isLoggedIn">
        <v-menu>
          <v-btn icon slot="activator">
            <v-icon>account_box</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              :to="{ name: 'paid_days_off', params: { user_id: user.uid } }"
            >
              <v-list-tile-title>有給休暇</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              :to="{ name: 'setting', params: { user_id: user.uid } }"
            >
              <v-list-tile-title>個人設定</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title v-on:click.stop="logOut"
                >ログアウト</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-content class="main-wrapper">
      <v-dialog v-model="isLoading" persistent width="120px">
        <v-card>
          <v-progress-circular
            :size="100"
            color="primary"
            indeterminate
            class="loader"
            >Loading</v-progress-circular
          >
        </v-card>
      </v-dialog>
      <router-view />
    </v-content>
    <v-footer color="deep-orange" class="non-printable" app>
      <span class="white--text">&copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
import auth from "@/components/fireAuthInit";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      drawer: false,
    };
  },
  created() {},
  computed: {
    userName() {
      return this.profile && this.profile.name ? this.profile.name : "";
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapGetters("app", ["isLoading"]),
  },
  methods: {
    ...mapActions("auth", ["logOut"]),
  },
};
</script>
<style lang="scss" scoped>
.loader {
  margin: 10px;
}
@media print{
  .non-printable{
    display: none;
  }
  .main-wrapper{
    padding: 10px !important;
  }
}
</style>




